import React from "react"
import { Image } from "./image.component"

class Video extends React.Component {
  constructor(props) {
    super(props)
    this.videoRef = React.createRef()
    this.state = {
      status: "stop",
      started: false
    }
  }

  playVideo() {
    const video = this.videoRef.current
    if (video) {
      video.play()
      video.controls = true
      video.onplay = () => {
        this.setState({ status: "play", started: true })
      }
      video.onpause = () => {
        this.setState({ status: "stop", started: true })
      }
    }
  }

  render() {
    const { src, thumbnail } = this.props
    const { status, started } = this.state
    return (
      <div className="cover-video">
        <video width="100%" ref={this.videoRef} src={src} />
        <Image className="w-100 video-thumbnail hi" style={{visibility: (started ? 'hidden' : 'visible')}} image={thumbnail} />
        <div
          className={"play-btn " + (status === "play" ? "hidden" : "")}
          onClick={() => this.playVideo()}
        >
          <Image className="play-btn" alt="video" image="play.png" />
        </div>
      </div>
    )
  }
}

export default Video
